import React from 'react';
import AtividadesDepartamento from '../components/atividades/AtividadesDepartamento';

const AtividadesDepartamentoPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-6">
      <h1 className="text-2xl font-bold mb-6">Atividades do Departamento</h1>
      <AtividadesDepartamento />
    </div>
  );
};

export default AtividadesDepartamentoPage;
